import React, { useEffect, useRef, useState } from 'react';
import useClickOutside from '../../hooks/useClickOutside';

const Dropdown = (props: any) => {
  const { label, items, onSelect, isReviewMode } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState('');
  const placeholder = label === 'Account*' ? 'Account' : 'Industry';
  const dropdownRef = useRef(null);

  const [searchText, setSearchText] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(() => items);

  useEffect(() => {
    setFilteredOptions(items.filter((name:string) => name.toLowerCase().includes(searchText.toLowerCase())));
  }, [searchText, items]);

  useClickOutside(dropdownRef, () => {
    setIsOpen(false);
  });

  const onSearchTextChange = (e: any) => {
    setShowDropdown(true);
    const value = e.target.value;
    setSearchText(value);
    // setIsOptionSelected(false);
    // setFilteredOptions(items.filter((name: string) => name.toLowerCase().includes(value.toLowerCase())));
  };

  const handleSelect = (item: string) => {
    setSearchText(item);
    setShowDropdown(false);
    onSelect(item); //  inform project modal of selected item
  };
  // const toggleDropdown = () => setIsOpen((prev) => !prev);
  return (
    <div className="c-create-project__acc-wrap -labelgap">
      <label className="text-left">{label}</label>
      <div className="c-tab-content -widthcontent">
        <div className={`c-tab-content__input-text ${isReviewMode ? '-reviewmode' : ''} `}>
          <div className="o-multi-select-two " tabIndex={0}>
            <div className={`o-multi-select-two__head ${showDropdown ? '-active' : ''}`}>
              <div className="o-input-wrap ">
                <i className="icon-search"></i>
                <input
                  type="text"
                  className="o-input -dropdown"
                  value={searchText}
                  id="input1"
                  name="input1"
                  placeholder={label === 'Client*' ? 'Search & Select Client' : 'Search & Select Industry'}
                  onChange={onSearchTextChange}
                  onClick={() => setShowDropdown((prev) => !prev)}
                />
              </div>
              <i
                className={`o-multi-select-two__arrow icon-caret ${showDropdown ? '-active' : ''}`}
                tabIndex={0}
                onClick={() => setShowDropdown((prev) => !prev)}
              ></i>
            </div>
            {true && (
              <div className={`o-multi-select-two__dropdown ${showDropdown ? '-active' : ''}`}>
                <ul className="o-multi-select-two__list">
                  {label === 'Client*' && (
                    <li>
                      <a
                        href="#"
                        role="option"
                        className="c-dropdown-item"
                        id="sample-dropdown-option-1"
                        aria-selected="false"
                        onClick={() => handleSelect('Create New Client')}
                        style={{ textAlign: 'left' }}
                      >
                        {' '}
                        Create New Client
                      </a>
                    </li>
                  )}
                  {filteredOptions?.map((account: any, index: any) => (
                    <a
                      href="#"
                      role="option"
                      className="c-dropdown-item"
                      id="sample-dropdown-option-2"
                      aria-selected="false"
                      onClick={() => handleSelect(account)}
                      key={index}
                      style={{ textAlign: 'left' }}
                    >
                      {account}
                    </a>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dropdown;
